module.exports = __webpack_public_path__ + "static/media/B.f5a0eeb8.png";


//////////////////
// WEBPACK FOOTER
// ./src/mobioastro/assets/images/B.png
// module id = 1348
// module chunks = 0